import { KitElement } from 'modules/teams/domain/enums/kit-element';
import { KitPattern } from 'modules/teams/domain/enums/kit-pattern';
import { KitType } from 'modules/teams/domain/enums/kit-type';
import { TeamResponseDto } from 'modules/teams/domain/interfaces/response-dto';
import { Team } from 'modules/teams/domain/interfaces/team';
import { TeamKit } from 'modules/teams/domain/interfaces/team-kit';
import { mapPlayerDtoToPlayer } from 'modules/tournaments/domain/data-mappers/championship-game-teams-mapper';
import { TEAM_DEFAULT_LOGO } from 'shared/constants/links';
import { getNormalizedDate } from 'shared/utils/get-normalized-date';

function mapKits(kits?: TeamResponseDto['kits']): TeamKit[] {
  if (!kits) return [];
  return kits.map((kit) => ({
    id: kit.id,
    type: kit.type.toLowerCase() as KitType,
    elements: kit.elements.map((el) => ({
      element: el.element.toLowerCase() as KitElement,
      attributes: {
        pattern: el.attributes.pattern.toLowerCase() as KitPattern,
        colors: el.attributes.colors,
      },
    })),
  }));
}

export function mapTeamResponseDto(teams: TeamResponseDto[]): Team[] {
  return teams.map((team) => ({
    id: team.id,
    name: team.name,
    shortName: team.shortName,
    logo: team.emblem?.id
      ? {
          id: team.emblem.id,
          url: team.emblem.externalUrl ?? TEAM_DEFAULT_LOGO,
        }
      : undefined,
    createdAt: team.createdAt && getNormalizedDate(team.createdAt),
    players: team.members?.map(mapPlayerDtoToPlayer) ?? [],
    entryRequests:
      team.entryRequest?.map((player) => ({
        ...mapPlayerDtoToPlayer(player),
        status: player.status,
      })) ?? [],
    sportType: team.tournament?.sportType?.toLowerCase(),
    kits: mapKits(team.kits),
  }));
}
